import { Water } from '@mui/icons-material'
import { ApplianceConfigAirWaterHeatPump } from './Appliance'
import { Trans } from 'react-i18next'
import { StrategySliders } from '../../components/StrategySliders'
import { CustomSwitch } from '../../components/atoms/CustomSwitch'
import { TemperatureRelayAppliance } from './TemperatureRelayAppliance'

export class AirWaterHeatPumpAppliance extends TemperatureRelayAppliance<ApplianceConfigAirWaterHeatPump> {

  get Icon() {
    return Water
  }

  getDefaultConfig(): ApplianceConfigAirWaterHeatPump {
    return Object.assign({
      advanced: false,
      strategy: 'MANUAL',
      plan_by_price: true,
      pv_priority: 10,
      saving_or_heat: 0,
      heat_preservation: 8,
      domestice_water: true,
      fixed_percentage: 40,
    }, super.getDefaultConfig())
  }

  drawSwitches(): React.ReactNode {
    return <>
      <CustomSwitch
        data-cy="switch-HotWater"
        onClick={() => this.setConfig('domestice_water', !this.getConfig('domestice_water'))}
        checked={this.getConfig('domestice_water')}
      /><Trans>This heat pump heats also domestic hot water.</Trans>
    </>
  }

  drawSliders(): React.ReactNode {
    return (
      <StrategySliders
        name1="saving_or_heat"
        slider1={[this.app.t('More Saving'), this.app.t('More Heat')]}
        values1={[-100, 100]}
        value1={this.getConfig('saving_or_heat')}
        title1={this.app.t('Do you prefer?')}

        name2="heat_preservation"
        slider2={['4h', '24h']}
        values2={[4, 24]}
        value2={this.getConfig('heat_preservation')}
        title2={this.app.t('Time window of optimization?')}

        onChange={(k, v) => { this.setConfig(k, v); this.applyConfig() }}
      />
    )
  }

  convert() {
    const ctrl = this.getOptimizerControl()
    const advanced = this.getConfig('advanced')
    const savingOrHeat: number = this.getConfig('saving_or_heat')

    return Object.assign({
      min_duty: advanced ? ctrl.getConfig('min_duty') : this.getConfig('domestice_water') ? Math.round(20 + 0.05 * savingOrHeat) : 0,
      max_duty: advanced ? ctrl.getConfig('max_duty') : Math.round(savingOrHeat < 0 ? 95 + 0.2 * savingOrHeat : 95 + 0.05 * savingOrHeat),
      min_duty_at: advanced ? ctrl.getConfig('min_duty_at') : Math.round(16 + 0.02 * savingOrHeat),
      max_duty_at: advanced ? ctrl.getConfig('max_duty_at') : Math.round(-15 + 0.05 * savingOrHeat),
      time_constant: this.getConfig('heat_preservation'),
    }, super.convert())
  }
}
